import http from "@/http-common";

export default class CustService {

	getList(_params) {
		//alert("_params = " + JSON.stringify(_params));
		return http.get('/ma/custs', { params: _params}).then(res => res.data);
	}

	getCodeList(_params) {
		//alert("cust = " + JSON.stringify(_params));
		return http.get('/ma/custs/code', { params: _params}).then(res => res.data);
	}

	getOne(_Id) {
		return http.get(`/ma/custs/${_Id}`).then(res => res.data);
	}

	insertOne(_data) {
		//alert("insertOne _data = " + JSON.stringify(_data));
		return http.post('/ma/custs',_data).then(res => res.data);
	}

	updateOne(_data) {
		return http.put('/ma/custs',_data).then(res => res.data);
	}

	deleteOne( _compSeq, _custSeq)
	{
		return http.delete(`/ma/custs/${_compSeq}/${_custSeq}`).then(res => res.data);
	}

	deleteList( _data)
	{
		return http.delete('/ma/custs/', {data:JSON.stringify(_data)}).then(res => res.data);
	}

}